import { createContext, FC, ReactNode, useContext, useMemo } from 'react';
import { useFirmFundFilter, UseFirmFundFilterReturn } from 'pages/Firms/hooks';

const IntelligenceContext = createContext<UseFirmFundFilterReturn | null>(null);

interface IntelligenceProviderProps {
  children: ReactNode;
}

export const IntelligenceProvider: FC<IntelligenceProviderProps> = ({ children }) => {
  const fundFilter = useFirmFundFilter();

  const value = useMemo<UseFirmFundFilterReturn>(
    () => ({
      fundOptions: fundFilter.fundOptions,
      isAllFundsSelected: fundFilter.isAllFundsSelected,
      isLoadingFunds: fundFilter.isLoadingFunds,
      selectedFund: fundFilter.selectedFund,
      selectedFundId: fundFilter.selectedFundId,
      setSelectedFund: fundFilter.setSelectedFund,
    }),
    [
      fundFilter.fundOptions,
      fundFilter.isAllFundsSelected,
      fundFilter.isLoadingFunds,
      fundFilter.selectedFund,
      fundFilter.selectedFundId,
      fundFilter.setSelectedFund,
    ]
  );

  return <IntelligenceContext.Provider value={value}>{children}</IntelligenceContext.Provider>;
};

export const useIntelligenceContext = (): UseFirmFundFilterReturn => {
  const value = useContext(IntelligenceContext);
  if (value === null) {
    throw new Error('useIntelligenceContext must be used within an IntelligenceProvider');
  }
  return value;
};
